import React, {Component} from "react";
import {inject, observer} from 'mobx-react';
import styled from 'styled-components'
import { PENDING_ANIMATION_MODES, PENDING_ANIMATION_TEXT } from "../../stores/PendingAnimationStore"

const AnimatedDiv = styled.div`
  transition: opacity 0.3s;
  font-size: ${props => props.fontSize};
  opacity: ${props => props.isTurningInvisible ? '0' : '1'};
  text-align: center;
`;

@inject('RootStore')
@observer
class OrderTextPending extends Component {
  render() {
    const { RootStore, value, fontSize, mode } = this.props;
    let displayText;

    if (mode === PENDING_ANIMATION_MODES.PENDING_CHECKING) {
       displayText = PENDING_ANIMATION_TEXT.PENDING_CHECKING
    } else if (mode === PENDING_ANIMATION_MODES.PENDING_REFUND ) {
      displayText = PENDING_ANIMATION_TEXT.PENDING_REFUND
    }

    const { isTurningInvisible, shouldDisplayPendingText } = RootStore.pendingCheckinAnimationStore;
    const displayValue = shouldDisplayPendingText ? displayText : value;
    const pendingCheckinFontSize = shouldDisplayPendingText ? RootStore.orderStore.boxedOrderCheckInFontSize : fontSize;
    return (
      <AnimatedDiv fontSize={pendingCheckinFontSize} isTurningInvisible={isTurningInvisible}>
        {displayValue}
      </AnimatedDiv>
    )
  }
}

@inject('RootStore')
@observer
export default class OrderText extends Component {
  render() {
    const props = this.props;
    const useNames = props.RootStore.configStore.useNames;
    const fontSize = useNames ? props.RootStore.orderStore.boxedOrderNameFontSize : props.RootStore.orderStore.boxedOrderFontSize;

    let orderText;
    if (props.pendingRefund) {
      orderText = <OrderTextPending
        value={props.value}
        fontSize={fontSize}
        mode={PENDING_ANIMATION_MODES.PENDING_REFUND}
      />
    } else if (props.pendingCheckin) {
      orderText = <OrderTextPending
        value={props.value}
        fontSize={fontSize}
        mode={PENDING_ANIMATION_MODES.PENDING_CHECKING}
      />
    } else {
      orderText = <div style={{fontSize}}>
        {props.value}
      </div>
    }

    return (
      <div style={props.style}>
        { orderText }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/order_stream_widget/OrderText.jsx